import React, { useMemo, useState } from "react";
import {
  Card,
  Button,
  Row,
  Col,
  Container,
  Badge,
  Form,
} from "react-bootstrap";
import Navbar from "../Navbar/Navbar";

// Utility to generate random coupon codes
function generateCoupon(length = 16) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let code = "";
  for (let i = 0; i < length; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}
export default function OfferCoupon({
  discount = "25% OFF",
  title = "Home Care Offer",
  description = "Apply for any standard or deep cleaning package",
  expiry = "Expires Oct 15, 2025",
}) {
  // generate coupon once per render
  const code = useMemo(() => generateCoupon(18), []);

  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) {
      alert("Please fill all fields");
      return;
    }
    setSubmitted(true);
  };

  const handleCopy = () => {
    try {
      navigator.clipboard?.writeText(code);
      alert(`Coupon code ${code} copied to clipboard!`);
    } catch (e) {
      alert("Unable to copy code");
    }
  };

  return (
    <>
    <Navbar/>
    <Container className="my-4">
      {/* Desktop / tablet card */}

      {!submitted ? (
        <Card className="shadow rounded-3">
          <Card.Body>
            <Badge bg="success" className="mb-2">
              Get Discount Coupon
            </Badge>
            <Card.Title className="h5 mb-3">{title}</Card.Title>
            <Card.Text className=" mb-4">{description}</Card.Text>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label style={{width:"100%",textAlign:"start"}}>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={{width:"100%",textAlign:"start"}}>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPhone">
                <Form.Label style={{width:"100%",textAlign:"start"}}>Mobile Number</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your mobile number"
                  required
                />
              </Form.Group>

              <Button type="submit"  className="w-100" style={{background:"#07448E",border:"none"}}>
                Submit & Get Coupon
              </Button>
            </Form>
          </Card.Body>
        </Card>
      ) : (
        <>
          <Card className="d-none d-md-flex flex-row shadow-lg rounded-3 overflow-hidden">
            <Card.Body className="w-50 d-flex flex-column justify-content-between p-4">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <Badge bg="success">Limited</Badge>
                  <Card.Title className="h4 fw-bold mb-0">{title}</Card.Title>
                </div>
                <Card.Text className="mt-3 text-muted">{description}</Card.Text>
              </div>

              <div className="mt-3 small text-muted">
                <div>
                  Terms: One coupon per booking. Valid for new & returning
                  customers.
                </div>
                <div>{expiry}</div>
              </div>
            </Card.Body>

            <Card.Body className="w-50 border-start d-flex flex-column justify-content-center align-items-start p-4">
              <div className="display-5 fw-bold text-success">{discount}</div>

              <Row className="align-items-center g-2 mt-3">
                <Col xs="auto">
                  <div className="border rounded px-3 py-2 bg-light">
                    <code className="fw-semibold">{code}</code>
                  </div>
                </Col>
                <Col xs="auto">
                  <Button variant="primary" onClick={handleCopy}>
                    Copy Code
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Mobile card */}
          <Card className="d-md-none shadow-sm rounded-3 overflow-hidden">
            <Card.Body className="p-3">
              <Row>
                <Col
                  xs={3}
                  className="d-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded"
                >
                  <div className="fw-bold text-success">{discount}</div>
                </Col>
                <Col xs={9}>
                  <div className="d-flex justify-content-between align-items-center">
                    <Card.Title className="h6 mb-0">{title}</Card.Title>
                    <small className="text-muted">{expiry}</small>
                  </div>
                  <Card.Text className="small text-muted mt-1">
                    {description}
                  </Card.Text>

                  <Row className="align-items-center g-2 mt-2">
                    <Col>
                      <div className="border rounded px-2 py-1 bg-light">
                        <code className="fw-semibold">{code}</code>
                      </div>
                    </Col>
                    <Col xs="auto">
                      <Button size="sm" variant="primary" onClick={handleCopy}>
                        Copy
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className="small text-muted text-center">
              Terms apply • Redeem at checkout
            </Card.Footer>
          </Card>

          {/* Sticky bottom copy button on small screens */}
          <div className="d-md-none fixed-bottom mb-3 px-3">
            <Button
              className="w-100"
              variant="primary"
              size="lg"
              onClick={handleCopy}
            >
              Copy {code}
            </Button>
          </div>
        </>
      )}
    </Container>
    </>
  );
}
